import React from 'react'

import { Box, useBreakpoint } from '@factorialco/deprecated-design-system'

import AmazonBlackCard from 'modules/referral_program/lib/assets/amazon_card_black.png'
import AmazonWhiteCard from 'modules/referral_program/lib/assets/amazon_card_white.png'

import AnimatedCard from './AnimatedCard'

interface AmazonCardsProps {
  enableAnimation?: boolean
}

const AmazonCards: React.FC<AmazonCardsProps> = ({ enableAnimation = false }) => {
  const { breakpoint, isMobile } = useBreakpoint()
  const isSmallScreen = breakpoint === 's'
  const isLargeScreen = breakpoint === 'l'

  const getBlackCardLeft = () => {
    if (isSmallScreen) return '20px'
    if (isLargeScreen) return '50px'
    return '80px'
  }

  const getWhiteCardLeft = () => {
    if (isSmallScreen) return '155px'
    if (isLargeScreen) return '185px'
    return '205px'
  }

  return (
    <Box
      style={{
        maxWidth: isMobile ? '100%' : breakpoint === 'l' ? '500px' : '720px',
        borderRadius: '12px',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flex: '1',
        backgroundImage: 'linear-gradient(135deg, #F8F0F2 0%, #FFF5E8 100%)',
      }}
    >
      <Box
        style={{
          position: 'relative',
          width: '535px',
          height: '300px',
          margin: '0 auto 24px',
        }}
      >
        <AnimatedCard
          imageSrc={AmazonBlackCard}
          altText="Amazon Gift Card"
          top="40px"
          left={getBlackCardLeft()}
          width="263px"
          height="163px"
          boxShadow="0 6px 12px rgba(0, 0, 0, 0.15)"
          zIndex={'0'}
          enableAnimation={enableAnimation}
        />

        <AnimatedCard
          imageSrc={AmazonWhiteCard}
          altText="Amazon Gift Card"
          top="128px"
          left={getWhiteCardLeft()}
          width="263px"
          height="163px"
          boxShadow="0 6px 20px rgba(0, 0, 0, 0.2)"
          zIndex={'1'}
          enableAnimation={enableAnimation}
        />
      </Box>
    </Box>
  )
}

export default AmazonCards
